import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardStore } from '@store';
import { CommonStandaloneModule } from '../../../shared/common-standalone.module';

@Component({
  selector: 'app-dashboard-refresh-modal',
  templateUrl: './dashboard-refresh-modal.component.html',
  styleUrls: ['./dashboard-refresh-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [forwardRef(() => CommonStandaloneModule), MatCardModule, MatButtonModule],
})
export class DashboardRefreshModalComponent {
  constructor(
    private dialogRef: MatDialogRef<DashboardRefreshModalComponent, void>,
    private dashboardStore: DashboardStore
  ) {}

  refreshData(): void {
    this.dashboardStore.fetchDashboard();
    this.dashboardStore.fetchTilesOrder();
    this.dialogRef.close();
  }
}
